import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';
import { NavigationService } from '../../Navigation/Services/navigation.service';

@Component({
  selector: 'app-reports',
  imports: [RouterModule],
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
})
export class ReportsComponent {
  private _navigationService = inject(NavigationService);
  private _router = inject(Router);
  private _destroyRef = inject(DestroyRef);

  constructor() {
    this.watchNavigation();
  }

  ngOnDestroy() {
    this._navigationService.clearSecondaryView();
  }

  private watchNavigation() {
    this.syncSecondaryNav(this._router.url);
    this._router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntilDestroyed(this._destroyRef)
      )
      .subscribe(event => this.syncSecondaryNav(event.urlAfterRedirects));
  }

  private syncSecondaryNav(url: string) {
    const path = url.split('?')[0].split('#')[0].replace(/\/$/, '');
    if (path.endsWith('/reports')) {
      this._navigationService.clearSecondaryView();
      return;
    }
    this._navigationService.setSecondaryView('reports');
  }
}
